import { render, staticRenderFns } from "./TravelFormAdmin.vue?vue&type=template&id=c0af99be&scoped=true&"
import script from "./TravelFormAdmin.vue?vue&type=script&lang=js&"
export * from "./TravelFormAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TravelFormAdmin.vue?vue&type=style&index=0&id=c0af99be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af99be",
  null
  
)

export default component.exports